import Api from '@services/api';
import {removeEmptyParams} from '@utils';

export default {
  getGlobalStats() {
    return Api()
      .get('/rm/global-stats')
      .then((res) => res.data);
  },
  prepare(filter) {
    return Api()
      .post('/rm/prepare', removeEmptyParams(filter))
      .then((res) => res.data);
  },
  indicator(uuid, key, interval) {
    return Api()
      .get(`/rm/indicator/${uuid}/${key}`, {params: {interval}})
      .then((res) => res.data);
  },
};
